import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ROUTE_CONSTANTS } from '../../../util/route.constants';
import { environment } from '../../../../environments/environment';
import { ForgotPasswordService } from '../../../services/forgot-password/forgot-password.service';
import { Router } from '@angular/router';
import { CVANotificationService } from '../../../services/cva-notification/cva-notification.service';
import { NotificationClassEnum } from '../../../models/notification-class.enum';
import { CVA_CONSTANTS } from '../../../util/constants';

@Component({
    standalone: false,
    selector: 'cva-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.scss',
    
})
export class ForgotPasswordComponent {

  cvaUI_url = environment.cvaUI_url
  fpForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  })
  showErrMsg: string = ''
  routes_constants = ROUTE_CONSTANTS;
  constructor(private readonly forgotPasswordService: ForgotPasswordService,
    private readonly cvaNotificationService: CVANotificationService,
    private readonly router: Router) {
    this.fpForm.valueChanges.subscribe(() => {
      this.showErrMsg = '';
    });
  }
  submitForm() {
    const emailControl = this.fpForm.get('email')
    if (!emailControl?.invalid) {
      console.log("Sending email to forgot password service");
      this.forgotPasswordService.forgotPassword(emailControl?.value).subscribe({
        next: (res: { success: boolean }) => {
          if (res?.success) {
            console.log("Password reset successful, redirecting to login page");
            this.cvaNotificationService.showNotification(CVA_CONSTANTS.MESSAGE.FORGOT_PASSWORD_LINK_SENT, NotificationClassEnum.INFO, 5000)
            this.router.navigate([`${ROUTE_CONSTANTS.LOGIN}`])
          }
        },
        error: () => {
          console.log("Password reset failed");
          this.showErrMsg = CVA_CONSTANTS.MESSAGE.INVALID_USER;
        }
      })
    }
  }

} 
